import React from "react";
import { Container, Grid, Image } from "semantic-ui-react";
import Helmet from "react-helmet";

import mext from "../../static/converted/logo_mext-min.png";

import mext_sport from "../../static/converted/mext_sportlich-min.jpg";

//import mext550_1 from "../../static/converted/leihboote_mext550_1-min.jpg";
//import mext550_2 from "../../static/converted/leihboote_mext550_2-min.jpg";
//import mext550_3 from "../../static/converted/leihboote_mext550_3-min.jpg";

import mext630_1 from "../../static/converted/leihboote_mext630_1-min.jpg";
//import mext630_2 from "../../static/converted/leihboote_mext630_2-min.jpg";
import mext630_3 from "../../static/converted/leihboote_mext630_3-min.jpg";
//import mext630_4 from "../../static/converted/leihboote_mext630_4-min.jpg";
import mann from "../../static/converted/9mann-min.jpg";

import guidingboot_zelt from "../../static/guiding_boot_zelt.jpg";

import Imgmodal from "../imgmodal";

const Leihboote = () => {
  const schemaOrgJSONLD = [
    {
      "@context": "http://schema.org",
      "@type": "Organization",
      sameAs: ["http://mext-boote.com"],
      address: {
        "@type": "PostalAddress",
        addressLocality: "Borgoforte, Italien",
        postalCode: "IT-46030",
        streetAddress: "Via Al Ponte 1"
      },
      email: "info(at)wallerwelt.com",
      alumni: [
        {
          "@type": "Person",
          name: "Markus Eule"
        }
      ],
      member: [
        {
          "@type": "Organization"
        }
      ],
      name: "Mext-Boote (Mext-Boote.com)",
      contactPoint: [
        {
          "@type": "ContactPoint",
          telephone: "+39-345-997-3997",
          contactType: "customer service"
        }
      ]
    }
  ];
  return (
    <Container id="Leihboote" className="main_content">
      <Helmet>
        {/* Schema.org tags */}
        <script type="application/ld+json">
          {JSON.stringify(schemaOrgJSONLD)}
        </script>
      </Helmet>

      <h1>Unsere Leihboote</h1>
      <a href="http://mext-boote.com/">
        <Image src={mext} floated="right" size="small" />
      </a>
      <p>
        Im Jahr 2014 strebten wir an, gemeinsam mit einem der bekanntesten
        Bootsarchitekten aus Italien, einer seit mehr als 30 jährig bestehender
        Bootsmanufaktur und einem Mechanikermeister, das für unsere Bedürfnisse
        perfekte Angelboot zu entwickeln.<br />Unsere Mext-Boote verbinden
        erstmals sportliches Design mit maximaler Funktionalität beim Fischen am
        Fluss und auf dem See. In Planungsbereichen wie Geräuschentwicklung der
        Außenhülle, Wendigkeit auf kleinem Raum und Spurtreue beim bespielweise
        Driftfischen sind unsere Boote Marktführer. Sie wurden 2017 mit dem
        Qualitec Design Award ausgezeichnet. <br />Alle unsere Leihboote sind
        mit einer Schlaffläche im Bug, hochwertigen Echoloten mindestens 16
        Rutenhaltern Sauerstoffpumpen für den Ködertransport 12 V Steckdosen 3{" "}
        <a href="https://www.restube.com/de/" target="_blank">
          Restube
        </a>{" "}
        2 Ankern einer E-Motorhalterung am Heck und allen sicherheitstechnichen
        Ausrüstung ausgestattet.
      </p>
      <a
        className="right floated"
        href="https://mext-boote.com/"
        target="_blank"
      >
        Mehr Infos zu unseren Booten
      </a>
      <br />
      <br />
      <Imgmodal img={mext_sport} fluid />

      <h2>Klasse 1+ Mext 630 (>=100PS) </h2>
      <Grid columns={2} stackable>
        <Grid.Column>
          <Imgmodal img={mext630_1} />
        </Grid.Column>
        <Grid.Column>
          <Imgmodal img={guidingboot_zelt} />
        </Grid.Column>
      </Grid>
      <p>
        Die Klasse 1+ ist mit 100PS oder mehr, einem Echolot Solix 12 mit
        Sidescan, Minnkota Bugmotor und dem Mext Bootszelt ausgestattet.
      </p>

      <h2>Klasse 1 Mext 630 (40-60PS)</h2>
      <Grid columns={2} stackable>
        <Grid.Column>
          <Imgmodal img={mext630_3} />
        </Grid.Column>
        <Grid.Column>
          <Imgmodal img={mann} />
        </Grid.Column>
      </Grid>      
    </Container>
  );
};

export default Leihboote;



// WEBPACK FOOTER //
// ./src/components/Leihboote/index.js